import React from 'react'

export default function Text<K>({
    label,
    onChange,
    props,
    name,
    disabled = false
}: {
    name: string
    label: string
    onChange: (rule: K) => void
    props: K
    disabled?: boolean
}) {
    return (
        <div>
            <label>{label}</label>
            <input
                disabled={disabled}
                type={'text'}
                onChange={({ target }) => onChange({ ...props, [name]: target?.value })}
                value={props[name]}
            />
        </div>
    )
}
export { Text }
